import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import jwt_decode from 'jwt-decode';
import { JwtService } from './jwt.service';
import { ConfigService } from './config.service';
import { LocalStorage } from '../utils/local.storage';
import { BaseService } from './base.service';
import { LoadUserDataService } from 'src/app/account/services/load-user-data.service';

const ACCESS_TOKEN = 'access_token';

@Injectable({
  providedIn: 'root'
})
export class AuthService extends BaseService {
  private currentUserSubject = new BehaviorSubject<any>(null);
  public currentUser$ = this.currentUserSubject.asObservable();

  private isAuthenticatedSubject = new BehaviorSubject<boolean>(false);
  public isAuthenticated$ = this.isAuthenticatedSubject.asObservable();
  private httpOptions: any = {
    headers: new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: 'Basic ZDctYXByaW1vcmhhLWludGVncmFjYW8tYXBwOmtIbTNCUWVCTFNnRkx2dkR6UVRXTHd3ZnlabUIzRTVuS2Y5SjN6cEVOc1ZHY0V2ODZrN0c4OVZrZW54YU5tcEhLSkg4NGtzQmtGS0syVnFaQ1JEcmdyNEhGOWd3UTdNRnd5cXhWcHFkYmRWUWJHNXZmc01qWlZhaEFQTHN4ZnlZ',
    }),
    withCredentials: true
  };

  constructor(
    httpClient: HttpClient,
    configService: ConfigService,
    jwtService: JwtService,
    private router: Router,
    private snackBar: MatSnackBar,
    private loadUserDataService: LoadUserDataService,
  ) {
    super(httpClient, configService, jwtService);
  }

  purgeAuth(): void {
    LocalStorage.clear();
    this.currentUserSubject.next({} as any);
    this.isAuthenticatedSubject.next(false);
    this.configService.get('logoutUrl').subscribe(logoutUrl => {
      (window).location.href = logoutUrl + '/account/login';
    });
  }

  getHeaderOptions(): any {
    return this.httpOptions;
  }

  setupJwt(data: object): void {
    if (!data.hasOwnProperty(ACCESS_TOKEN)) {
      return;
    }

    this.jwtService.saveToken(data[ACCESS_TOKEN]);

    const jwtDecode: any = jwt_decode(this.jwtService.getToken());

    LocalStorage.setItem('usuario', jwtDecode);

    this.snackMessage('Conectado com sucesso', 'HTTP - 200');

    this.loadUserDataService.get();

    let url = '';
    if (jwtDecode.userProfile == 3) {
      url = '/headhunter';
    }
    if (jwtDecode.userProfile == 1) {
      url = '/hao';
    }
    if (jwtDecode.userProfile == 2) {
      url = '/web-admin';
    }
    if (jwtDecode.userProfile == 4) {
      url = '/share';
    }

    this.router.navigate([url]);
  }

  logout(): void {
    this.purgeAuth();
  }

  snackMessage(messageInfo: any, action: any): void {
    const config = new MatSnackBarConfig();
    config.duration = 2500;
    config.direction = 'ltr';
    config.verticalPosition = 'top';
    this.snackBar.open(messageInfo, action, config);
  }
}
